import React from "react";
import { Dropdown as CarbonDropdown } from "@carbon/react";

const Dropdown = ({ className, ...props }) => {
  const mergedClassName = ["mm-dropdown", className].filter(Boolean).join(" ");
  return <CarbonDropdown {...props} className={mergedClassName} />;
};

export default Dropdown;
